<template>
	<div v-if="wrapper">
		<slot></slot>
	</div>
	<li v-else>
		<slot></slot>
	</li>
</template>

<script>
export default {
	name: 'LanguagesSwitch',
	props: ['wrapper']
}
</script>

<style scoped>

</style>
